import * as React from 'react';
import Common from '../utilities/common';
import $ from "jquery";
import { Snackbar, Alert, AlertTitle, SlideProps, Slide, IconButton, Dialog, DialogTitle, DialogContent, TextField, DialogActions, Button } from '@mui/material';
import ReactInterval from 'react-interval';
import { Entity } from '../utilities/Permisos';
import { TransitionProps } from '@mui/material/transitions';
import NotificationsIcon from '@mui/icons-material/Notifications';
import NotificationsActiveIcon from '@mui/icons-material/NotificationsActive';
import NotificationsNoneIcon from '@mui/icons-material/NotificationsNone';

export interface INotificacionSnackbarState {
    data: any[];
    openForm: boolean;
}

export interface INotificacionSnackbarProps {
    openForm?: boolean;
    sendTo?: number;
    entity?: Entity;
}

export default class NotificacionSnackbar extends React.Component<INotificacionSnackbarProps, INotificacionSnackbarState> {
    _notificationMessage: string = '';

    public constructor(props: INotificacionSnackbarProps) {
        super(props);

        this.state = {
            data: [],
            openForm: false
        }
    }

    componentWillReceiveProps(nextProps: Readonly<INotificacionSnackbarProps>, nextContext: any): void {
        this.setState(
            {
                openForm: nextProps.openForm!
            }
        )
    }

    componentDidMount(): void {
        this.CheckNotificaciones();
    }

    public render(): React.ReactElement<{}> {
        return (
            <React.Fragment>
                <ReactInterval enabled={true} timeout={10000} callback={() => {
                    this.CheckNotificaciones();
                }}/>
                <IconButton onClick={() => {
                    window.location.href = '/notificaciones';
                }}>
                    {
                        this.state.data.length > 0 && (
                            <NotificationsActiveIcon htmlColor='#ffffff'/>
                        )
                    }
                    {
                        this.state.data.length == 0 && (
                            <NotificationsNoneIcon htmlColor='#ffffff'/>
                        )
                    }
                </IconButton>
                {
                    this.state.data.length > 0 && this.state.data.map((notification: any, index: number) => {
                        return (
                            <Snackbar open={true} key={index} anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }} style={{minWidth: '25%', bottom: `${(index * 100) + 24}px`}}>
                                <Alert severity="info" variant="filled" sx={{ width: '100%' }} onClose={() => {
                                    this.Checked(notification.id);
                                }}>
                                    <AlertTitle>
                                        {
                                            this.GetAlertTitle(notification)
                                        }
                                    </AlertTitle>
                                    {
                                        notification.message
                                    }
                                </Alert>
                            </Snackbar>
                        )
                    })
                }
                <Dialog open={this.state.openForm} fullWidth>
                    <DialogTitle>
                        Enviar notificación
                    </DialogTitle>
                    <DialogContent>
                        <TextField fullWidth rows={5} multiline onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                            this._notificationMessage = event.target.value;
                        }}></TextField>
                    </DialogContent>
                    <DialogActions>
                        <Button variant='contained' onClick={this.Send.bind(this)}>Enviar</Button>
                        <Button variant='contained' onClick={() => {
                            this.setState(
                                {
                                    openForm: false
                                }
                            )
                        }}>Cancelar</Button>
                    </DialogActions>
                </Dialog>
            </React.Fragment>
        )
    }

    private GetAlertTitle(notification: any): string {
        let title: string = '';

        switch(notification.entidadId) {
            case Entity.Apellidos:
                title = "Apellidos";
                break;
            case Entity.Clientes:
                title = "Clientes";
                break;
            case Entity.ComunidadesAutonomas:
                title = "Comunidades autónomas";
                break;
            case Entity.Configuracion:
                title = "Configuración";
                break;
            case Entity.Consolidaciones:
                title = "Consolidaciones";
                break;
            case Entity.Dashboard:
                title = "Cuadro de mando";
                break;
            case Entity.Datos:
                title = "Datos";
                break;
            case Entity.IPS:
                title = "IPs";
                break;
            case Entity.Municipios:
                title = "Municipios";
                break;
            case Entity.NivelesPermisos:
                title = "Niveles de permisos";
                break;
            case Entity.NombresPila:
                title = "Nombres de pila";
                break;
            case Entity.Normalizaciones:
                title = "Normalizaciones";
                break;
            case Entity.Permisos:
                title = "Permisos";
                break;
            case Entity.Provincias:
                title = "Provincias";
                break;
            case Entity.TiposVía:
                title = "Tipos de vís";
                break;
            case Entity.Tramero:
                title = "Tramero";
                break;
            case Entity.Usuarios:
                title = "Usuarios";
                break;
            case Entity.VariacionesApellidos:
                title = "Variaciones de apellidos";
                break;
            case Entity.VariacionesMunicipios:
                title = "Variaciones de municipios";
                break;
            case Entity.VariacionesNombresPila:
                title = "Variaciones de nombres de pila";
                break;
            case Entity.VariacionesTiposVía:
                title = "Variaciones de tipos de vía";
                break;
        }

        return title;
    }

    private CheckNotificaciones(): void {
        let url = `${Common.END_POINT}/notificaciones`;
        
        $.ajax((
            {
                url: url,
                type: "GET",
                headers: {
                    "Accept": "application/json",
                    "Content-Type": "application/json"
                },
                beforeSend: function (xhr) {
                    xhr.setRequestHeader('Authorization', `Bearer ${Common.GetToken()}`);
                }
            }
        )).done((response: any[]) => {
            console.log(response);
            this.setState(
                {
                    data: response
                }
            );
        }).fail((jqXHR: any, textStatus: any, errorThrown: any) => {
            if(jqXHR.status == 401) {
                const source = window.location.href;
                window.location.href = `/login?source=${source}`;
            }
        });
    }

    private Checked(id: number): void {
        let url = `${Common.END_POINT}/notificaciones/${id}/checked`;
        
        $.ajax((
            {
                url: url,
                type: "POST",
                headers: {
                    "Accept": "application/json",
                    "Content-Type": "application/json"
                },
                beforeSend: function (xhr) {
                    xhr.setRequestHeader('Authorization', `Bearer ${Common.GetToken()}`);
                }
            }
        )).done(() => {
            this.CheckNotificaciones();            
        }).fail((jqXHR: any, textStatus: any, errorThrown: any) => {
            if(jqXHR.status == 401) {
                const source = window.location.href;
                window.location.href = `/login?source=${source}`;
            }
        });
    }

    private Send(): void {
        let url = `${Common.END_POINT}/notificaciones/send/`;
        const notification: any = {};
        notification.entityId = this.props.entity;
        notification.userId = this.props.sendTo;
        notification.message = this._notificationMessage;

        $.ajax((
            {
                url: url,
                type: "POST",
                data: JSON.stringify(notification),
                headers: {
                    "Accept": "application/json",
                    "Content-Type": "application/json"
                },
                beforeSend: function (xhr) {
                    xhr.setRequestHeader('Authorization', `Bearer ${Common.GetToken()}`);
                }
            }
        )).done(() => {
            this.setState(
                {
                    openForm: false
                }
            )
        }).fail((jqXHR: any, textStatus: any, errorThrown: any) => {
            if(jqXHR.status == 401) {
                const source = window.location.href;
                window.location.href = `/login?source=${source}`;
            }
        });
    }
}